import '../../../common/js/3rdparty/date.js';
import '../../../common/js/3rdparty/prism.js';

import $ from 'webpack-zepto';
window.$ = $;

import Accordion from '../../../common/js/Accordion.js';
import Ajax from '../../../common/js/Ajax.js';
import Navigation from '../../../common/js/Navigation.js';
import SelectableTableRow from '../../../common/js/SelectableTableRow.js';
import WidgetLoader from '../../../common/js/WidgetLoader.js';

import DatePickerWidget from '../../../common/js/datepicker/DatePickerWidget.js';
import EstrellaWidget from './EstrellaWidget.js';
import LoginWidget from './auth/LoginWidget.js';
import LogoutWidget from './auth/LogoutWidget.js';

$(() => {
	Ajax.initialize();

	Accordion.initialize();
	Navigation.initialize();
	SelectableTableRow.initialize();

	WidgetLoader.add('DatePickerWidget', DatePickerWidget);
	WidgetLoader.add('EstrellaWidget', EstrellaWidget);
	WidgetLoader.add('LoginWidget', LoginWidget);
	WidgetLoader.add('LogoutWidget', LogoutWidget);

	WidgetLoader.initialize();
});
